/* eslint-disable */
import {put, takeEvery} from "redux-saga/effects";
import {Survey} from "../../models/survey";
import {
    GetSurveyById,
    GetSurveyByIdComplete,
    AddSurveyAnswer,
    AddSurveyAnswerComplete,
    AddSurveyAnswerFailed,
    GetAllSurveyComplete,
    AddSurveyComplete,
    UpdateSurveyComplete,
    UpdateSurvey,
    AddSurvey,
    UpdateSurveyFailed
} from "../actions/SurveyActions";
import SurveyApi from "../apis/SurveyApi";
import SurveyEvents from "../events/SurveyEvents";

// アンケート情報取得
function* LoadSurveyById({userId, videoId}: ReturnType<typeof GetSurveyById>) {
    const result: Survey[] = yield SurveyApi.GetSurveyById(userId, videoId);
    console.log("SurveyoSaga: LoadSurveyById", result);
    yield put(GetSurveyByIdComplete(result));
}

// アンケート回答登録
function* AddSurveyAnswerWorker({userId, videoId, surveyId, questionId, choiceId}: ReturnType<typeof AddSurveyAnswer>) {
    const result: any = yield SurveyApi.AddSurveyAnswer(userId, videoId, surveyId, questionId, choiceId);
    if (result.response && result.response.status !== 200) {
        yield put(AddSurveyAnswerFailed(result.stack));
   } else {
        yield put(AddSurveyAnswerComplete(result));
   }
}

// 全アンケート情報取得
function* GetAllSurveyWorker() {
    const result: Survey[] = yield SurveyApi.GetAllSurvey();
    console.log("SurveyoSaga: GetAllSurveyWorker", result);
    yield put(GetAllSurveyComplete(result));
}

// アンケート新規追加
function* AddSurveyWorker({newSurvey}: ReturnType<typeof AddSurvey>) {
    const result: Survey = yield SurveyApi.AddSurvey(newSurvey);
    yield put(AddSurveyComplete(result));
}

// アンケート更新
function* UpdateSurveyWorker({updateSurvey}: ReturnType<typeof UpdateSurvey>) {
    const result: any = yield SurveyApi.UpdateSurvey(updateSurvey);
    console.log("SurveyoSaga: UpdateSurveyWorker", result);
    if(result.response && result.response.status !== 200){
        yield put(UpdateSurveyFailed());
   }
    else{
        yield put(UpdateSurveyComplete(result));
   }
}

export default function* ProjectSaga() {
    yield takeEvery(SurveyEvents.LoadSurveyByIdStarted, LoadSurveyById);
    yield takeEvery(SurveyEvents.AddSurveyAnswerStarted, AddSurveyAnswerWorker);
    yield takeEvery(SurveyEvents.GetAllSurveyStarted, GetAllSurveyWorker);
    yield takeEvery(SurveyEvents.AddSurveyStarted, AddSurveyWorker);
    yield takeEvery(SurveyEvents.UpdateSurveyStarted, UpdateSurveyWorker);
}
